import {
    SET_MESSAGES,
    ADD_MESSAGE,
    RESHOW_LATEST_MOTD,
    MOTDS_CHANGED,
    MOTD_OUTDATED,
    MOTD_FETCHING,
    MOTD_FETCHED,
    MOTD_FETCH_FAILED,
} from './constants'
import { createMessageToast, createMessageToasts } from '../api'
import { getLocale } from '../../imports'

export function motdOutdated(timeStamp) {
    return {
        type: MOTD_OUTDATED,
        payload: timeStamp,
    }
}

export function fetchingMotd(locale, timeStamp) {
    return {
        type: MOTD_FETCHING,
        payload: { locale, timeStamp },
    }
}

export function fetchedMotd(locale, motd) {
    return {
        type: MOTD_FETCHED,
        payload: { locale, toast: createMessageToast(motd) },
    }
}

export function fetchFailedMotd(locale, timeStamp) {
    return {
        type: MOTD_FETCH_FAILED,
        payload: { locale, timeStamp },
    }
}

export function setMessages(motds) {
    return {
        type: SET_MESSAGES,
        payload: createMessageToasts(motds),
    }
}

export function addMessage(message, options = {}) {
    return (dispatch, getState) => {
        const locale = getLocale(getState())
        dispatch({
            type: ADD_MESSAGE,
            payload: { locale, toast: createMessageToast(message, options) },
        })
    }
}

export function reshowLatestMotd() {
    return {
        type: RESHOW_LATEST_MOTD,
    }
}

export function motdsChanged(motds) {
    return {
        type: MOTDS_CHANGED,
        payload: motds,
    }
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/motds/actions.js